/* eslint-disable no-console */

import { register } from 'register-service-worker';

// `npm run serve` runs with --mode production, so VUE_APP_ENVIROMENT is 'production'
// locally too. On the dev server /service-worker.js is vue-cli-plugin-pwa's no-op
// worker, whose activate handler navigates every open tab — registering it locally
// just reloads the page for no benefit. Skip it and clear any copy left behind.
const isLocalhost = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);

if (isLocalhost) {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            registrations
                .filter((registration) =>
                    [registration.active, registration.waiting, registration.installing].some((worker) =>
                        worker?.scriptURL.endsWith('/service-worker.js'),
                    ),
                )
                .forEach((registration) => registration.unregister());
        });
    }
} else if (process.env.VUE_APP_ENVIROMENT === 'production' || process.env.VUE_APP_ENVIROMENT === 'development') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log(
                'App is being served from cache by a service worker.\n' +
                    'For more details, visit https://goo.gl/AFskqB',
            );
        },
        registered() {
            console.log('Service worker has been registered.');
        },
        cached() {
            console.log('Content has been cached for offline use.');
        },
        updatefound() {
            console.log('New content is downloading.');
        },
        updated() {
            console.log('New content is available; please refresh.');
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.');
        },
        error(error) {
            console.error('Error during service worker registration:', error);
        },
    });
}
